<div class="dialog-container">
  <div class="dialog-header">
    <h2>{{ isEditMode ? 'Editar Sócio' : 'Cadastrar Sócio' }}</h2>
    <button mat-icon-button [mat-dialog-close]="null" class="close-button" matTooltip="Fechar diálogo">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content mb-2">
    <app-mat-spinner-overlay [overlay]="true" *ngIf="loading"></app-mat-spinner-overlay>

    <form [formGroup]="socioForm" (ngSubmit)="onConfirmar()">

      <div class="row g-2 mb-2">
        <div class="col-12">
          <mat-label class="radio-label">Tipo de Documento</mat-label>
          <mat-radio-group formControlName="tipoDocumento" class="radio-group">
            <mat-radio-button value="CPF">CPF</mat-radio-button>
            <mat-radio-button value="CNPJ">CNPJ</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div class="row g-2">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nome {{ isCpf ? 'do Sócio' : 'da Empresa' }}</mat-label>
            <input matInput formControlName="nome" maxlength="200" required />
            <mat-error *ngIf="socioForm.get('nome')?.hasError('required')">Obrigatório</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row g-2">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ isCpf ? 'CPF' : 'CNPJ' }}</mat-label>
            <input matInput formControlName="cpfCnpj"
              [textMask]="{ mask: documentoMask, guide: false }"
              [placeholder]="isCpf ? '000.000.000-00' : 'AA.AAA.AAA/0001-00'"
              required />
            <mat-error *ngIf="socioForm.get('cpfCnpj')?.hasError('required')">Obrigatório</mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Campos específicos CPF -->
      <ng-container *ngIf="isCpf">
        <div class="row g-2">
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Data de Nascimento</mat-label>
              <input matInput [matDatepicker]="pickerNascimento" formControlName="dataNascimento"
                placeholder="Selecione a data" required />
              <mat-datepicker-toggle matSuffix [for]="pickerNascimento"></mat-datepicker-toggle>
              <mat-datepicker #pickerNascimento></mat-datepicker>
              <mat-error *ngIf="socioForm.get('dataNascimento')?.hasError('required')">Obrigatório</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row g-2">
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nome do Pai</mat-label>
              <input matInput formControlName="nomePai" maxlength="200" required />
              <mat-error *ngIf="socioForm.get('nomePai')?.hasError('required')">Obrigatório</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row g-2">
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nome da Mãe</mat-label>
              <input matInput formControlName="nomeMae" maxlength="200" required />
              <mat-error *ngIf="socioForm.get('nomeMae')?.hasError('required')">Obrigatório</mat-error>
            </mat-form-field>
          </div>
        </div>
      </ng-container>

      <!-- Campos específicos CNPJ -->
      <ng-container *ngIf="!isCpf">
        <div class="row g-2">
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Razão Social</mat-label>
              <input matInput formControlName="razaoSocial" maxlength="200" />
            </mat-form-field>
          </div>
        </div>

        <div class="row g-2">
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nome Reduzido</mat-label>
              <input matInput formControlName="nomeReduzido" maxlength="200" />
            </mat-form-field>
          </div>
        </div>

        <div class="row g-2">
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Data de Fundação</mat-label>
              <input matInput [matDatepicker]="pickerFundacao" formControlName="dataFundacao"
                placeholder="Selecione a data" />
              <mat-datepicker-toggle matSuffix [for]="pickerFundacao"></mat-datepicker-toggle>
              <mat-datepicker #pickerFundacao></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </ng-container>

      <div class="row g-2 mt-2">
        <div class="col d-flex justify-content-end gap-2">
          <button mat-flat-button class="btn-confirmar" type="submit"
            [disabled]="loading || !socioForm.valid">
            <mat-icon>check</mat-icon> Confirmar
          </button>
          <button mat-flat-button type="button" (click)="onCancelar()" [disabled]="loading">
            <mat-icon>close</mat-icon> Cancelar
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
